<template>
  <v-dialog :value="dialogProp.show" persistent max-width="600">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{ $t('Изменение банковских реквизитов') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <ValidationObserver ref="editForm">
          <v-row>
            <v-col v-if="dialogProp.accountType" cols="12">
              <text-view
                  :display="dialogProp.accountType
                    ? $t(BANK_ACCOUNT_TYPES_ENUM[dialogProp.accountType])
                    : null"
                  multiline
                  :label="$t('Тип счета')" />
              <!-- <federal-bank-account
                  v-if="hasBankAccount && isFederal"
                  ref="bankAccount"
                  :bank-account="account"
                  :save-method="save" /> -->
              <credit-org-bank-account
                  v-if="hasBankAccount && isCreditOrg"
                  ref="bankAccount"
                  :bank-account="bankAccountCredit"
                  @input="changeBankAccountCreditField" />
            </v-col>
            <v-col v-else>
              {{ $t('Нет данных для редактирования') }}
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            v-if="hasBankAccount"
            id="saveBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="validateAndSave">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import CreditOrgBankAccount from './CreditOrgBankAccount.vue'
  // import FederalBankAccount from './FederalBankAccount.vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import { BANK_ACCOUNT_TYPES_ENUM } from '@/constants/enums.js'
  import { BANK_ACCOUNT_TYPES, DICTIONARY_TYPES } from '@/constants/business'

  export default {
    components: {
      GeneralError,
      CreditOrgBankAccount,
      // FederalBankAccount,
      TextView
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => ({
          show: false,
          accountType: null,
          bankAccount: null,
          callback: null
        })
      }
    },
    data () {
      return {
        isLoading: false,
        BANK_ACCOUNT_TYPES_ENUM,
        DICTIONARY_TYPES,
        bankAccountCredit: {
          bankName: null,
          bik: null,
          correspondentAccount: null,
          personalAccount: null
        }
      }
    },
    computed: {
      account () {
        return { ...this.dialogProp.bankAccount } || {}
      },
      isFederal () {
        return this.dialogProp.accountType === BANK_ACCOUNT_TYPES.FEDERAL
      },
      isCreditOrg () {
        return this.dialogProp.accountType === BANK_ACCOUNT_TYPES.CREDIT
      },
      hasBankAccount () {
        return !!this.account &&
          !!this.account.bankAccountId
      },
      title () {
        return this.isCreditOrg
          ? this.$t('Счет в кредитной организации')
          : this.isFederal
            ? this.$t('Счет в территориальном органе Федерального казначейства/финансовом органе субъекта РФ или муниципальном образовании')
            : null
      }
    },
    created () {
      for (const prop in this.bankAccountCredit) {
        this.bankAccountCredit[prop] = this.account[prop]
      }
    },
    methods: {
      changeBankAccountCreditField: async function ({ property, value }) {
        this.bankAccountCredit[property] = value
      },
      validateAndSave: async function () {
        try {
          const isValidated = await this.$refs.editForm.validate()
          if (!isValidated) {
            throw new Vue.errorsTypes.ValidationError()
          }
          if (this.dialogProp.callback) {
            this.isLoading = true
            await this.dialogProp.callback({
              ...this.bankAccountCredit,
              bankAccountId: this.account.bankAccountId,
              accountType: this.account.accountType
            })
            this.isLoading = false
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
